import React, {useEffect} from 'react';
import {View, Text, StyleSheet, TouchableOpacity, Image, Dimensions} from 'react-native';
import {useDispatch} from 'react-redux';
import {globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import Width from '../../../assets/Width';
import FastImage from '../../../common/FastImage';
import {Button} from '../../../components/core/Button';
import {showLoader} from '../../../commonComponents/Loader/loader.actions';
import RupeeVal from '../../../commonComponents/RupeeVal';
import {
  formatPL,
  getReturns,
  giveCorrectPrice,
  isMobile,
} from '../../../utils/commonMethods';
import LiquidityFields from './liquidityFields';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {convert} from '../../../locale/translateText';
import {
  globalConfigurableData,
  GlobalScreens,
} from '../../../utils/globalConstant';
import {useNavigation} from '@react-navigation/native';
import {useLiveProbe} from './useLiveProbes';
import {defaulteventimage} from '../../../utils/images';
import { getSubcategoryImage } from '../../../utils/subcategoryImages';

const PortfolioLiveCard = ({
  item,
  onSellCancelClick,

  contestId,
}) => {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  let liveProbeDetail = useLiveProbe(item);
  const probe = liveProbeDetail?.probes;
  let summary = probe?.summary;
  let calls = probe?.calls;
  let liquidity = probe?.liquidity;

  const matched_yes_contracts = probe?.total_matched_contract_yes
    ? probe?.total_matched_contract_yes
    : 0;
  const matched_no_contracts = probe?.total_matched_contract_no
    ? probe?.total_matched_contract_no
    : 0;
  const matched_contracts = matched_yes_contracts + matched_no_contracts;
  const avg_price_matched_yes_contracts = probe?.avg_price_matched_contract_yes
    ? probe?.avg_price_matched_contract_yes
    : 0;
  const avg_price_matched_no_contracts = probe?.avg_price_matched_contract_no
    ? probe?.avg_price_matched_contract_no
    : 0;
  const profitLoss =
    summary && summary[2].value !== '- ' ? parseFloat(summary[2].value) : '- ';
  const isCDAEvent = probe?.is_price_editable ? true : false;

  const totalPendingOrder = calls?.map(call => {
    return call.rank === -1;
  });
  let isPendingOrder = false;
  totalPendingOrder?.includes(true)
    ? (isPendingOrder = true)
    : (isPendingOrder = false);
  const initialState = isCDAEvent && !matched_contracts && isPendingOrder;

  const checkForRemoveShareShow =
    liquidity && liquidity?.investedLiqTokenCount ? true : false;

  let newSellPriceYes = probe?.newSellPriceYes;
  // probe.is_price_editable
  //   ? probe.newYCP
  //   : probe.execution_price_yes;
  let newSellPriceNo = probe?.newSellPriceNo;
  // probe.is_price_editable
  //   ? probe.newNCP
  //   : probe.execution_price_no;
  newSellPriceNo = newSellPriceNo
    ? giveCorrectPrice({yPrice: parseFloat(newSellPriceNo)})
    : null;
  newSellPriceYes = newSellPriceYes
    ? giveCorrectPrice({nPrice: parseFloat(newSellPriceYes)})
    : null;

  const checkForMergeButtonShow = () => {
    if (
        (probe?.is_price_editable &&
        matched_yes_contracts > 0 &&
        matched_no_contracts > 0) ||
        (!probe?.is_price_editable &&
        probe?.is_variable_liquidity_pool &&
        matched_yes_contracts > 0 &&
        matched_no_contracts > 0)
    ) {
      return true;
    }
    return false;
  };

  const PendingRow = () => {
    return (
      <View
        style={{
          marginTop: 10,
          paddingTop: 15,
          paddingHorizontal: 15,
        }}>
        <View style={{flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10}}>
          <FormTextLabel
            labelStyles={{
              ...globalFontStyle.appFontSubText,
              color: globalConfigurableData.primaryTextColor1,
              fontSize: 12,
              fontWeight: '600',
              color: globalConfigurableData.secondaryTextColor1,
            }}
            label={'PENDING ORDERS'}
          />
        </View>
        <View>
          {calls.map(call => {
            if (call.rank === -1) {
              return (
                <View
                  key={call.orderid}
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginBottom: 10,
                  }}>
                  <View style={{flexDirection: 'row', flex: 1}}>
                    <View style={[styles.rowCol, {alignItems: 'flex-start'}]}>
                      <FormTextLabel
                        labelStyles={[
                          globalFontStyle.appFontSubText,
                          {
                            fontSize: 10,
                            fontWeight: '300',
                            color: globalConfigurableData.secondaryTextColor1,
                            opacity: 0.6
                          },
                          styles.marginRow
                        ]}
                        label={'TYPE'}
                      />
                      <FormTextLabel
                        labelStyles={{
                          textAlign: 'center',
                          color: globalConfigurableData.primaryTextColor1,
                        }}
                        label={call.status === 'A' ? 'Buy' : 'Sell'}
                      />
                    </View>
                    <View style={[styles.rowCol, {alignItems: 'flex-start'}]}>
                      <FormTextLabel
                        labelStyles={[
                          globalFontStyle.appFontSubText,
                          {
                            fontSize: 10,
                            fontWeight: '300',
                            color: globalConfigurableData.secondaryTextColor1,
                            opacity: 0.6
                          },
                          styles.marginRow
                        ]}
                        label={'QUANTITY'}
                      />
                      <Text
                        style={{
                          color: globalConfigurableData.primaryTextColor1,
                        }}>
                        {call.noofcontracts
                          ? getReturns(call.noofcontracts)
                          : call.noofcontracts}{' '}
                        x {''}
                        {convert(call.callvalue === 'Y' ? 'Yes' : 'No')}
                      </Text>
                    </View>
                    <View style={[styles.rowCol, {alignItems: 'flex-start'}]}>
                      <FormTextLabel
                        labelStyles={[
                          globalFontStyle.appFontSubText,
                          {
                            fontSize: 10,
                            fontWeight: '300',
                            color: globalConfigurableData.secondaryTextColor1,
                            opacity: 0.6
                          },
                          styles.marginRow
                        ]}
                        label={'PRICE'}
                      />
                      <Text
                        style={{
                          color: globalConfigurableData.primaryTextColor1,
                        }}>
                        {' '}
                        {giveCorrectPrice({nPrice: call.coins})}
                      </Text>
                    </View>
                  </View>
                  <View style={isMobile() ? {} : styles.btnSellWeb}>
                    <Button
                      variant="outline"
                      size="sm"
                      inactive
                      onPress={() => onSellCancelClick({probe, isCancel: true, call})}
                    >
                      Cancel
                    </Button>
                  </View>
                </View>
              );
            } else {
              return null;
            }
          })}
        </View>
      </View>
    );
  };

  const MatchedContract = ({isYes}) => {
    return (
      <View
        style={{
          flexDirection: 'row',
          paddingTop: 15,
          paddingHorizontal: 15,
        }}>
        <View style={{flexDirection: 'row', flex: 1}}>
          <View style={[styles.rowCol, {alignItems: 'flex-start'}]}>
            <FormTextLabel
              labelStyles={[
                globalFontStyle.appFontSubText,
                {
                  fontSize: 10,
                  fontWeight: '300',
                  color: globalConfigurableData.secondaryTextColor1,
                  opacity: 0.6
                },
                styles.marginRow
              ]}
              label={'QUANTITY'}
            />
            <FormTextLabel
              labelStyles={{color: globalConfigurableData.primaryTextColor1}}
              label={isYes ? ' x Yes' : ' x No'}
              rest={{
                value: isYes
                  ? getReturns(matched_yes_contracts)?.toFixed(2)
                  : getReturns(matched_no_contracts)?.toFixed(2),
              }}
            />
          </View>
          <View style={[styles.rowCol, {alignItems: 'flex-start'}]}>
            <FormTextLabel
              labelStyles={[
                globalFontStyle.appFontSubText,
                {
                  fontSize: 10,
                  fontWeight: '300',
                  color: globalConfigurableData.secondaryTextColor1,
                  opacity: 0.6
                },
                styles.marginRow
              ]}
              label={'BUY PRICE'}
            />
            <Text style={{color: globalConfigurableData.primaryTextColor1}}>
              {isYes
                ? `${giveCorrectPrice({
                    yPrice: avg_price_matched_yes_contracts,
                  })} `
                : `${giveCorrectPrice({
                    nPrice: avg_price_matched_no_contracts,
                  })}`}
            </Text>
          </View>
          <View style={[styles.rowCol, {alignItems: 'flex-start'}]}>
            <FormTextLabel
              labelStyles={[
                globalFontStyle.appFontSubText,
                {
                  fontSize: 10,
                  fontWeight: '300',
                  color: globalConfigurableData.secondaryTextColor1,
                  opacity: 0.6
                },
                styles.marginRow
              ]}
              label={'SELL PRICE'}
            />
            <Text style={{color: globalConfigurableData.primaryTextColor1}}>
              {isYes
                ? `${
                    newSellPriceYes && newSellPriceYes !== 'null'
                      ? newSellPriceYes
                      : '-'
                  }`
                : `${
                    newSellPriceNo && newSellPriceNo !== 'null'
                      ? newSellPriceNo
                      : '-'
                  }`}
            </Text>
          </View>
        </View>

        <View style={isMobile() ? {} : styles.btnSellWeb}>
          <Button
            variant={isYes ? "yes-inactive" : "no-inactive"}
            size="sm"
            outline
            onPress={() => onSellCancelClick({probe, isYes})}
          >
            Sell
          </Button>
        </View>
      </View>
    );
  };

  const onPortfolioTitlecClick = () => {
    dispatch(showLoader());
    if (contestId) {
      navigation.navigate('ContestEvents', {
        contestId: contestId,
        eventId: probe?.id,
        isMulti: probe?.parent_id === -1 ? true : false,
        probeInfo: probe,
      });
    } else {
      navigation.navigate('Event', {
        eventId: probe?.id,
        isMulti: probe?.parent_id === -1 ? true : false,
        probeInfo: probe,
      });
    }

    //navigation.navigate("Event", { eventData: probe, probeInfo: probe });
  };

  const screenWidth = Dimensions.get('window').width;
  
  const getImageSize = () => {
    if (screenWidth < 768) { // mobile
      return 45;  
    } else if (screenWidth < 1024) { // tablet
      return 45;
    } else { // desktop
      return 45;
    }
  };

  const imageSize = getImageSize();

  const randomImages = [
    'https://cdn.britannica.com/64/171264-050-C7253301.jpg',
    'https://cdn.britannica.com/35/238335-050-2CB2EB8A/Lionel-Messi-Argentina-Netherlands-World-Cup-Qatar-2022.jpg', 
    'https://cdn.britannica.com/56/199056-050-CCC44482/Jeff-Bezos-2017.jpg',
    'https://cdn.britannica.com/99/236599-050-1831D9C0/President-Joe-Biden-2023.jpg',
    'https://cdn.britannica.com/42/193142-050-F69B1A23/Mark-Zuckerberg-2010.jpg'
  ];

  const getImage = () => {
    return probe?.imageurl || getSubcategoryImage(probe?.subcategory) || defaulteventimage();
  };

  return (
    <View>
      <View
        style={[
          globalStyle.cardContainer,
          {
            paddingHorizontal: 0,
            borderColor: GlobalScreens.Portfolio.borderColor,
          },
        ]}>
        <View style={{paddingHorizontal: 15}}>
          <TouchableOpacity
            style={styles.upperRow}
            onPress={onPortfolioTitlecClick}>
            <View style={{flexDirection: 'row', alignItems: 'center'}}>
              <Image
                style={[styles.cardImg, {
                  width: imageSize,
                  height: imageSize,
                  objectFit: 'cover'
                }]}
                source={getImage()}
                contentFit="cover"
                transition={1000}
              />
              <View style={{
                flex: 1,
                marginLeft: 16,
                justifyContent: (probe?.subtitle && probe?.subtitle.trim()) ? 'flex-start' : 'center'
              }}>
                <Text
                  style={[
                    globalFontStyle.appFontHeading,
                    {color: globalConfigurableData.primaryTextColor1}
                  ]}
                  numberOfLines={2}>
                  {probe?.title}
                </Text>
                {probe?.subtitle && probe?.subtitle.trim() && (
                  <Text
                    style={[
                      globalFontStyle.appFontBody,
                      {color: globalConfigurableData.secondaryTextColor1}
                    ]}
                    numberOfLines={1}>
                    {probe?.subtitle}
                  </Text>
                )}
              </View>
            </View>
          </TouchableOpacity>
        </View>
        {probe?.probe_type === 'promo' && (
          <View style={styles.smileCoinBlk}>
            <Text
              style={[
                globalFontStyle.appSmall10Bold,
                {color: globalConfigurableData.globalThemeColor},
              ]}>
              Token Points Event
            </Text>
          </View>
        )}

        <View
          style={{
            marginTop: 15,
            flex: 1,
            borderTopWidth: 0.75,
            borderTopColor: globalConfigurableData.borderColor,
          }}
        />

        {matched_yes_contracts ? <MatchedContract isYes={true} /> : null}
        {matched_no_contracts ? <MatchedContract isYes={false} /> : null}
        {checkForMergeButtonShow() && (
          <View style={{paddingHorizontal: 15, marginTop: 15}}>
            <Button
              variant="outline"
              size="sm"
              inactive
              onPress={() => onSellCancelClick({probe, isMerge: true})}
              style={[
                {
                  backgroundColor: 'rgba(10, 87, 255, 0.1)',
                },
              ]}
              textStyle={{
                color: Colors.tradexBlue,
              }}
            >
              Merge Shares
            </Button>
          </View>
        )}
        {isCDAEvent && isPendingOrder ? <PendingRow /> : null}
        {liquidity ? <LiquidityFields liquidity1={liquidity} /> : null}
        <View style={{paddingHorizontal: 15, flexDirection: 'row'}}>
          {isPendingOrder && (
            <View style={{flexDirection: 'row', flex: 1, gap: 10}}>
              <Button
                variant="outline"
                size="sm"
                inactive
                onPress={() => onSellCancelClick({probe, isCancel: true, isCancelAll: true})}
                style={[
                  {
                    marginTop: 15,
                    width: '100%'
                  },
                ]}
              >
                Cancel All
              </Button>
            </View>
          )}
          {checkForRemoveShareShow ? (
            <Button
              variant="rm-liquidity"
              size="sm"
              inactive
              onPress={() => onSellCancelClick({probe, isRemoveShare: true})}
              style={[
                styles.btnExternalStyle,
                {
                  marginTop: 15,
                  marginLeft: isPendingOrder ? 10 : 0,
                },
              ]}
            >
              Remove Shares
            </Button>
          ) : null}
        </View>
      </View>
    </View>
  );
};

export default React.memo(PortfolioLiveCard);

const styles = StyleSheet.create({
  cardImg: {
    borderRadius: 8,
    overflow: 'hidden',
  },
  upperRow: {},
  priceBlock: {
    flexDirection: 'row',
    backgroundColor: Colors.grey3,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 100,
    justifyContent: 'space-between',
    borderWidth: 0.2,
    marginTop: 20,
    marginBottom: 30,
  },
  rowCol: {
    flex: 1,
    flexBasis: 0,
    flexShrink: 0,
    alignItems: 'center',
  },
  rowCol1: {
    flex: 1,
    flexBasis: 0,
    flexShrink: 0,
    alignItems: 'flex-end',
  },
  sellTxt: {
    borderWidth: 0.5,
    paddingHorizontal: 15,
    paddingVertical: 5,
    borderRadius: GlobalScreens.Portfolio.btnBorderRadius,
    overflow: 'hidden',
    color: GlobalScreens.Event.noBtnTxt,
    backgroundColor: GlobalScreens.Portfolio.noBtnBlock,
    borderColor: GlobalScreens.Portfolio.noBtnBorder,
  },
  sellTxtAnimation: {
    //borderWidth: 0.5,
    paddingHorizontal: 15,
    paddingVertical: 5,
    borderRadius: GlobalScreens.Portfolio.btnBorderRadius,
    overflow: 'hidden',
    color: GlobalScreens.Event.noBtnTxt,
    //backgroundColor: GlobalScreens.Portfolio.noBtnBlock,
    //borderColor: GlobalScreens.Portfolio.noBtnBorder,
  },
  cancelTxt: {
    paddingHorizontal: 10,
  },
  marginRow: {
    marginBottom: 5,
    color: globalConfigurableData.primaryTextColor1,
  },
  valText: {
    color: globalConfigurableData.primaryTextColor1,
  },
  profitLossBlock: {
    paddingHorizontal: 20,
    paddingVertical: 5,
    backgroundColor: Colors.grey3,
    borderRadius: 100,
    borderWidth: 0.75,
    borderColor: GlobalScreens.Portfolio.borderColor,
  },
  pendingOrderBlock: {
    paddingHorizontal: 20,
    paddingVertical: 5,
    backgroundColor: Colors.grey3,
    borderRadius: 100,
    borderWidth: 0.75,
    borderColor: GlobalScreens.Portfolio.borderColor,
    position: 'absolute',
    top: -15,
    left: (Width.width - 200) / 2,
  },
  liquidityBlock: {
    backgroundColor: Colors.grey3,
    paddingVertical: 5,
  },
  btnExternalStyle: {
    borderColor: 'rgb(39, 174, 96)',
    borderWidth: 0.2,
    paddingVertical: 8,
    width: 150,
  },
  btnSellWeb: {
    flex: 1,
    flexBasis: 0,
    flexShrink: 0,
    alignSelf: 'flex-end',
    alignContent: 'flex-end',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  smileCoinBlk: {
    position: 'absolute',
    right: 0,
    top: 0,
    paddingHorizontal: 10,
    paddingVertical: 2,
    backgroundColor: globalConfigurableData.primaryBtnColor,
    borderRadius: 2,
  },
});
